import { createSelector } from 'reselect';
import { rateQuoteSelector } from './rate-quote/rate-quote';

export const rateQuoteRequestSelector = createSelector(rateQuoteSelector, (rateQuote) =>
  rateQuote.map(({ rateQuoteRequest }) => rateQuoteRequest)
);
